import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { DanhMucTieuChuanSanXuat } from 'src/app/shared/DanhMucTieuChuanSanXuat.model';
import { BaseService } from './Base.service';
@Injectable({
    providedIn: 'root'
})
export class DanhMucTieuChuanSanXuatService extends BaseService{
    constructor(public httpClient: HttpClient) {
        super(httpClient);
        this.controller = "DanhMucTieuChuanSanXuat";
    }
}

